"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
exports.default = (function (_a) {
    var children = _a.children, theme = _a.theme, className = _a.className, iconName = _a.iconName, _b = _a.iconSize, iconSize = _b === void 0 ? 1.4 : _b, bold = _a.bold, smaller = _a.smaller, small = _a.small, medium = _a.medium, large = _a.large, spaced = _a.spaced, uppercase = _a.uppercase, dark = _a.dark, gray = _a.gray, blue = _a.blue, orange = _a.orange, purple = _a.purple, deepPurple = _a.deepPurple, green = _a.green, red = _a.red, others = tslib_1.__rest(_a, ["children", "theme", "className", "iconName", "iconSize", "bold", "smaller", "small", "medium", "large", "spaced", "uppercase", "dark", "gray", "blue", "orange", "purple", "deepPurple", "green", "red"]);
    var _c;
    return (React.createElement("button", tslib_1.__assign({ className: classnames_1.default(theme.link, className, (_c = {},
            _c[theme.bold] = bold,
            _c[theme.smaller] = smaller,
            _c[theme.small] = small,
            _c[theme.medium] = medium || (!smaller && !small && !large),
            _c[theme.large] = large,
            _c[theme.spaced] = spaced,
            _c[theme.uppercase] = uppercase,
            _c[theme.dark] = dark || (!blue && !orange && !purple && !deepPurple && !green && !red && !gray),
            _c[theme.gray] = gray,
            _c[theme.blue] = blue,
            _c[theme.orange] = orange,
            _c[theme.purple] = purple,
            _c[theme.deepPurple] = deepPurple,
            _c[theme.green] = green,
            _c[theme.red] = red,
            _c)) }, others),
        iconName ? React.createElement(icon_1.Icon, { className: theme.icon, size: iconSize, iconName: iconName }) : null,
        children ? React.createElement("div", { className: theme.label }, children) : null));
});
